export class SecurityReviewResult {
  status?: string;
  message?: string;
  securityId?: number;
}
